
import { ref, onMounted, reactive, defineComponent, computed } from 'vue'
import DataTable from '@/views/components/table/HjpDataTable.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
// import TabView from 'primevue/tabview'
// import TabPanel from 'primevue/tabpanel'
import Card from 'primevue/card'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
// import Form from './Form.vue'
import PositionTab from './components/tabs/PositionTab.vue'
import RequirementTab from './components/tabs/RequirementTab.vue'

export default defineComponent({
  components: {
    // DataTable,
    // Form,
    HjpTabView,
    PositionTab,
    RequirementTab,
    Card
  },
  setup() {
    const moduleStore = 'position'
    const router = useRouter()
    const store = useStore()
    // const currentTab = ref(0)
    const currentTab = computed({
      get: () => store.state[moduleStore].pageState,
      set: (value) => {
        store.dispatch('position/setPositionPageState', value)
      }
    })
    const arrayTab = ref([
      { title: 'Daftar Divisi', value: 0 },
      { title: 'Jenis Persyaratan', value: 1 },
    ])

    const tabChange = (val: any) => {
      currentTab.value = val
    }

    const onShowStatus = (data: any) => {
      // console.log('store', store.state)
      router.push({
        name: 'master-position-detail',
        params: {
          // id: encryptDecriptMethods.encrypt(data)
        }
      })
    }

    const onShowDetailAct = (data: any) => {
      // console.log('store', store.state)
      router.push({
        name: 'master-position-detail',
        params: {
          id: encryptDecriptMethods.encrypt(data)
        }
      })
    }
    // const slotBank = 'MsBank.Name'
    // const slotChannelBank = 'MsChannelBanks.OaAccount'
    // const getBankChannelId = (data: any) => {
    //   console.log('data', data)
    // }
    return {
      onShowDetailAct,
      onShowStatus,
      arrayTab,
      currentTab,
      tabChange
    }
  }
})
